import { render, staticRenderFns } from "./affordSetData.vue?vue&type=template&id=49d26ce2&"
import script from "./affordSetData.vue?vue&type=script&lang=js&"
export * from "./affordSetData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports